import { InputType } from '~/schema';
import { WorksheetField } from '../../../worksheets/common/components/Field';
import WorksheetForm from '../../../worksheets/common/components/WorksheetForm';
import { ExpensesUnit, UnitDecimals } from '~/constants';

export default function SubscriptionManagement() {
  return (
    <WorksheetForm>
      <WorksheetField
        type="radio"
        fieldLabel="Do you have recommended subscription management assumptions?"
        schemaKey="subscriptionManagementAssumptionsFlag"
        values={[
          { label: 'Yes and I’ll input them below', value: true },
          { label: 'No, investor to make own assumptions', value: false },
        ]}
        inline
        stretched
      />
      <WorksheetField
        fieldLabel="Subscription management costs"
        type="number"
        schemaKey="subscriptionExpenseAmount"
        numberType={InputType.DOLLARS}
        unitField="subscriptionExpenseUnit"
        units={[
          {value: ExpensesUnit.KWDC, label: 'per kWdc', decimals: UnitDecimals.KWDC},
          {value: ExpensesUnit.YEAR, label: 'per year', decimals: UnitDecimals.YEAR},
        ]}
        defaultUnit={ExpensesUnit.KWDC}
      />
      <WorksheetField.Row>
        <WorksheetField
          fieldLabel="Annual escalator"
          schemaKey="subscriptionExpenseEscalator"
          type="number"
          numberType={InputType.PERCENT}
          decimals={UnitDecimals.PERCENT}
        />
        <WorksheetField
          fieldLabel="Expected term"
          schemaKey="subscriptionExpenseExpectedTerm"
          type="number"
          decimals={UnitDecimals.YEAR}
          label="years"
          placeholder="Enter term length"
        />
      </WorksheetField.Row>
      <WorksheetField
        fieldLabel="Notes"
        placeholder="Please use this field to describe the project’s ongoing subscription management costs."
        schemaKey="subscriptionExpenseNotes"
        type="textarea"
        optional
      />
    </WorksheetForm>
  );
}